var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 4,
    fill: "#F4A807"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.233 40V34.2045C18.233 32.5379 18.5455 30.8049 19.1705 29.0057C19.8144 27.1875 20.6856 25.4735 21.7841 23.8636C22.9015 22.2348 24.1515 20.8617 25.5341 19.7443L30.3068 22.8409C29.1894 24.5265 28.2519 26.2879 27.4943 28.125C26.7557 29.9432 26.3958 31.9508 26.4148 34.1477V40H18.233ZM32.6364 40V34.2045C32.6364 32.5379 32.9489 30.8049 33.5739 29.0057C34.2178 27.1875 35.089 25.4735 36.1875 23.8636C37.3049 22.2348 38.5549 20.8617 39.9375 19.7443L44.7102 22.8409C43.5928 24.5265 42.6553 26.2879 41.8977 28.125C41.1591 29.9432 40.7992 31.9508 40.8182 34.1477V40H32.6364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextQuote);
export default __webpack_public_path__ + "static/media/textQuote.f13274899eaafd8f343b7f416e801710.svg";
export { ForwardRef as ReactComponent };